var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollMar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.97C23 19.84 19.87 22.97 16 22.97L17.05 21.22",
    stroke: "#34656D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.96997C1 4.09997 4.13 0.969971 8 0.969971L6.95 2.71997",
    stroke: "#34656D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61963 13.0699H9.42963C10.0496 13.0699 10.5596 13.63 10.5596 14.2C10.5596 14.82 10.0596 15.33 9.42963 15.33H6.61963V13.0699Z",
    stroke: "#34656D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61963 15.33H9.83963C10.5496 15.33 11.1296 15.83 11.1296 16.46C11.1296 17.08 10.5496 17.59 9.83963 17.59H6.61963V15.33Z",
    stroke: "#34656D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41943 17.58V18.7",
    stroke: "#34656D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.41943 11.95V13.0699",
    stroke: "#34656D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4997 8.66998C21.4997 12.08 18.7397 14.84 15.3297 14.84H14.8397C14.6097 11.81 12.1897 9.38997 9.15967 9.15997V8.66998C9.15967 5.25998 11.9197 2.5 15.3297 2.5C18.7397 2.5 21.4997 5.25998 21.4997 8.66998Z",
    stroke: "#34656D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8498 15.33C14.8498 18.74 12.0898 21.4999 8.67977 21.4999C5.26977 21.4999 2.50977 18.74 2.50977 15.33C2.50977 11.92 5.26977 9.15991 8.67977 9.15991C8.83977 9.15991 8.98977 9.16993 9.15977 9.17993C12.1898 9.40993 14.6098 11.8299 14.8398 14.8599C14.8398 15.0099 14.8498 15.16 14.8498 15.33Z",
    stroke: "#34656D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollMar);
export default __webpack_public_path__ + "static/media/CollMar.b7a22f43b410f669ba3de9119d647034.svg";
export { ForwardRef as ReactComponent };